export class HoldingUiState {
    constructor(search, filterState, sortStat, sum) {
        this.searchState = search;
        this.filterUiState = filterState;
        this.sortDataUiState = sortStat;
        this.isSummarize = sum;
    }
}
